/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendMessageBatch.defs.js'
export * as $defs from './sendMessageBatch.defs.js'
